/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DomoEmbedData } from '../models/domo-embed-data';
@Injectable({
  providedIn: 'root',
})
class DomoDashboardViewsService extends __BaseService {
  static readonly DomoDashboardViewsListDomoDashboardViewsPath = '/domo-reporting/dashboard-views';
  static readonly DomoDashboardViewsGetDomoDashboardViewEmbedDataPath = '/domo-reporting/dashboard-views/{viewId}/embed-data';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * list visible domo dashboards
   *
   * Retrieves a list of all possible views that the authenticated user has access to.
   */
  DomoDashboardViewsListDomoDashboardViewsResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/domo-reporting/dashboard-views`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * list visible domo dashboards
   *
   * Retrieves a list of all possible views that the authenticated user has access to.
   */
  DomoDashboardViewsListDomoDashboardViews(): __Observable<null> {
    return this.DomoDashboardViewsListDomoDashboardViewsResponse().pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * get domo embed link
   *
   * Retrieves the embedToken and embedURL for the specified viewId which is required on the client side to embed the Domo dashboard.
   * @param viewId index of the dashboard for which to generate the embed data
   * @return Ok
   */
  DomoDashboardViewsGetDomoDashboardViewEmbedDataResponse(viewId: number): __Observable<__StrictHttpResponse<DomoEmbedData>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/domo-reporting/dashboard-views/${encodeURIComponent(String(viewId))}/embed-data`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DomoEmbedData>;
      })
    );
  }
  /**
   * get domo embed link
   *
   * Retrieves the embedToken and embedURL for the specified viewId which is required on the client side to embed the Domo dashboard.
   * @param viewId index of the dashboard for which to generate the embed data
   * @return Ok
   */
  DomoDashboardViewsGetDomoDashboardViewEmbedData(viewId: number): __Observable<DomoEmbedData> {
    return this.DomoDashboardViewsGetDomoDashboardViewEmbedDataResponse(viewId).pipe(
      __map(_r => _r.body as DomoEmbedData)
    );
  }
}

module DomoDashboardViewsService {
}

export { DomoDashboardViewsService }
